var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTg = function SvgTg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0-.2h496.3V496H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#tg_svg__a)",
    transform: "translate(0 .3)scale(1.0316)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe300",
    d: "M0-.2h744V496H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#118600",
    d: "M0 201.5h744v99.7H0zM0 0h744v99.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80000",
    d: "M0 0h297.1v301.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130.3 124.3c0-.9 18.3-51.5 18.3-51.5l16.6 50.6s55.6 1.7 55.6.8-44 33.2-44 33.2 20.7 58.1 19.9 56.5-48.1-34.9-48.1-34.9-48.2 33.2-47.3 33.2 18.2-54.7 18.2-54.7L76.4 125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#118600",
    d: "M0 396.4h744v99.7H0z"
  }))));
};
export default SvgTg;